import React from 'react';
import { Routes, Route } from 'react-router-dom';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import CoverageAreas from './components/CoverageAreas';
import HomePage from './pages/HomePage';
import AboutPage from './pages/AboutPage';
import ContactPage from './pages/ContactPage';
import ServiceDetailPage from './pages/ServiceDetailPage';

function App() {
  return (
    <div className="min-h-screen bg-white font-sans text-gray-900 antialiased selection:bg-blue-100 selection:text-blue-900">
      <Navbar />
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/om-os" element={<AboutPage />} />
        <Route path="/kontakt" element={<ContactPage />} />
        <Route path="/services/:slug" element={<ServiceDetailPage />} />
      </Routes>
      <CoverageAreas />
      <Footer />
    </div>
  );
}

export default App;
